module.exports = __webpack_public_path__ + "img/box9-12.5fb4813c.png";